import { AutogenModelFakProfile, AutogenRowFakProfile } from "./autogen/AutogenModelFakProfile";

export class ModelFakProfile extends AutogenModelFakProfile<RowFakProfile> {
    constructor() {
        super(RowFakProfile);
    }
}

export class RowFakProfile extends AutogenRowFakProfile {
}